import { LoadingButton } from "@mui/lab";
import { Box, Dialog, Typography, Button, TextField } from "@mui/material";
import { MutableRefObject } from "react";
import { useTranslation } from "react-i18next";

interface Props {
    open: boolean,
    errorMessage: string;
    loading: boolean
    ownerPassword: MutableRefObject<HTMLInputElement>
    newPassword: MutableRefObject<HTMLInputElement>;
    confirmNewPassword: MutableRefObject<HTMLInputElement>
    onCancel: VoidFunction,
    onConfirm: VoidFunction
}


const ChangePasswordForm = ({ open, onCancel, loading, errorMessage, onConfirm, ownerPassword, newPassword, confirmNewPassword }: Props) => {
    const { t } = useTranslation('global');

    return <Dialog
        open={open}
    >
        <Box sx={{ width: '400px', height: '450px', display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
            <Box>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box>
                        <Typography sx={{ textAlign: 'center' }}>{t("Enter Your Password")}</Typography>
                        <TextField size="small" type="password" margin="normal" inputRef={ownerPassword} />
                        <Typography sx={{ textAlign: 'center' }}>{t("Enter new password")}</Typography>
                        <TextField size="small" type="password" margin="normal" inputRef={newPassword} />
                        <Typography sx={{ textAlign: 'center' }}>{t("Confirm new password")}</Typography>
                        <TextField size="small" type="password" margin="normal" inputRef={confirmNewPassword} />
                    </Box>
                </Box>
                {errorMessage && <Typography color='error' sx={{ textAlign: 'center' }}>{errorMessage}</Typography>}
                <Box mt={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                        variant="contained"
                        onClick={onCancel}
                        sx={{
                            textTransform: 'none',
                            mr: 1,
                            width: 100,
                            height: 40,
                            background: '#f4f6f8',
                            color: '#3a3b3c',
                            '&:hover': {
                                background: 'gray',
                                color: "#f4f6f8"
                            },
                        }}
                    >
                        No
                    </Button>
                    <Button variant='contained' color='secondary' onClick={onConfirm} sx={{ textTransform: 'none', color: '#fff', width: 100, height: 40 }}>
                        {
                            loading ?
                                <LoadingButton loading >
                                    Loading...
                                </LoadingButton>
                                : "Yes"
                        }
                    </Button>
                </Box>
            </Box>
        </Box>
    </Dialog>
}
export default ChangePasswordForm;